// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yDxr","right":"styles_right__3qPPM"};